import { render } from "./TrailsSection.vue?vue&type=template&id=04685f38"
import script from "./TrailsSection.vue?vue&type=script&lang=js"
export * from "./TrailsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__